import React, { Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import check from "../../../../assets/check.png";
import "./modal.scss";

const IncliniFollowUp = ({ okayClickHandler, name,title,procedure }) => {
    function ReplaceConsultationType(messaage){
        if(messaage.includes("6")){
          return (messaage.replace("consultation type 6",procedure))
        }
    }
    return (
        <div className="myschedule-modal">
            <>
                <div className="text-center align-items-center">
                    <img
                        src={check}
                        alt="Success"
                        style={{ width: "60px", height: "60px" }}
                    />
                    <p className="font-weight-bold my-1 modal-heading">
                        Time Slot added successfully
                    </p>

                    <p className="mt-2 mb-3 modal-paragraph">
                    {ReplaceConsultationType(title)}
                        {/* Selected time slot will be opened up for In-Clinic Regular appointments */}
                    </p>
                    <p className="font-weight-bold">Do you want to Add a Procedure?</p>
                </div>
                <div className="d-flex justify-content-center mt-3 btn-container">
                    <Button
                        className="btn secondary-button rounded-pill mt-3 p-2 px-3"//"border-0 rounded-pill mr-2"
                        // style={{
                        //     backgroundColor: "white",
                        //     color: "#17BAE0",
                        //     width: "140px",
                        //     height: "44px",
                        //     border: "1px solid !important"
                        // }}
                        onClick={()=>okayClickHandler('later')}
                    >
                        Maybe Later
                </Button>
                    <Button
                        className="btn primary-cta-button rounded-pill mt-3 p-2 px-5 mx-lg-4" //"border-0 rounded-pill  ml-2"
                        // style={{
                        //     backgroundColor: "#17BAE0",
                        //     color: "#fff",
                        //     width: "140px",
                        //     height: "44px",
                        // }}
                        onClick={()=>okayClickHandler('yes')}
                    >
                        Yes
                </Button>
                </div>
            </>
        </div>
    );
};

export default IncliniFollowUp;
